module.exports = require("./../internal/prefix") + "next";
